import React, { Component } from "react";
import InputRange from "react-input-range";

class RangeSlider extends Component
{
    state = {
        value: {
            min: this.props.minValue,
            max: this.props.maxValue
        }
    };

    onChange = (value) => {
        this.setState({ value }, () => {
            this.props.onChange(value);
        });
    };

    render() {

        return(
            <div className={'range-slider'}>
                <InputRange {...this.props}/>
            </div>
        )
    }
}

export default RangeSlider;
